import { Suspense } from 'react';

import { Route, Switch } from 'react-router-dom';

import {
    CONSENT_REVIEW_URL,
    CREDIT_CARD_BASE_URL,
    PREFERENCES_URL
} from './constants';
import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../modals/fallbackErrorModal/FallbackErrorModal';
import MainContentPending from '../pageStructure/mainContentPending';
import { CreditCardDashboard } from './dashboard/CreditCardDashboard';
import { ConsentReviewView } from './preferences/consent/review/ConsentReviewView';
import { PreferencesView } from './preferences/PreferencesView';

export const CreditCard = () => {
    return (
        <Switch>
            <Route exact path={`${CREDIT_CARD_BASE_URL}/`}>
                <CreditCardDashboard />
            </Route>
            <Route exact path={`${PREFERENCES_URL}`}>
                <ErrorBoundary fallback={() => <FallbackErrorModal />}>
                    <Suspense fallback={<MainContentPending />}>
                        <PreferencesView />
                    </Suspense>
                </ErrorBoundary>
            </Route>
            <Route exact path={CONSENT_REVIEW_URL}>
                <ErrorBoundary fallback={() => <FallbackErrorModal />}>
                    <Suspense fallback={<MainContentPending />}>
                        <ConsentReviewView />
                    </Suspense>
                </ErrorBoundary>
            </Route>
        </Switch>
    );
};
